import { defaultGapBetweenSelectedSeatsRuleOptions, defaultMustFillSofaSeatsPartialSelectionRuleOptions, defaultSingleSeatGapFromAnAisleRuleOptions, defaultSingleSeatGapFromUnavailableSeatRuleOptions } from '@vista-digital/occ-domain';
import { Validator } from '@vista-digital/validator';
import { occSeatingGapBetweenSelectedSeatsRuleConfigValidator } from './seat-selection-rules/gap-between-selected-seats-rule';
import { occSeatingSeatSelectionRuleConfigValidator } from './seat-selection-rules/seat-selection-rule';
import { occSeatingSingleSeatGapFromAnAisleRuleConfigValidator } from './seat-selection-rules/single-gap-from-aisle-rule';
import { occSeatingSingleSeatGapFromUnavailableSeatRuleConfigValidator } from './seat-selection-rules/single-gap-from-unavailable-seat-rule';
import { occSeatingSinglePartialSofaRuleConfigValidator } from './seat-selection-rules/single-partial-sofa-rule';
export const defaultOccSeatingSelectionRulesConfig = {
    cannotLeaveGapsBetweenSelectedSeats: {
        enabled: true,
        options: defaultGapBetweenSelectedSeatsRuleOptions
    },
    cannotLeaveSingleSeatGapFromAisle: {
        enabled: true,
        options: defaultSingleSeatGapFromAnAisleRuleOptions
    },
    cannotLeaveSingleSeatGapFromUnavailableSeat: {
        enabled: true,
        options: defaultSingleSeatGapFromUnavailableSeatRuleOptions
    },
    mustFillSofaSeats: {
        enabled: true,
        options: defaultMustFillSofaSeatsPartialSelectionRuleOptions
    },
    mustSelectAssociatedWheelchairSeat: {
        enabled: true
    },
    mustRespectSeatSelectionLimits: {
        enabled: true
    }
};
export const occSeatingSelectionRulesConfigValidatorSchema = {
    cannotLeaveGapsBetweenSelectedSeats: occSeatingGapBetweenSelectedSeatsRuleConfigValidator,
    cannotLeaveSingleSeatGapFromAisle: occSeatingSingleSeatGapFromAnAisleRuleConfigValidator,
    cannotLeaveSingleSeatGapFromUnavailableSeat: occSeatingSingleSeatGapFromUnavailableSeatRuleConfigValidator,
    mustFillSofaSeats: occSeatingSinglePartialSofaRuleConfigValidator,
    mustSelectAssociatedWheelchairSeat: occSeatingSeatSelectionRuleConfigValidator,
    mustRespectSeatSelectionLimits: occSeatingSeatSelectionRuleConfigValidator
};
export const occSeatingSelectionRulesConfigValidator = Validator.object(occSeatingSelectionRulesConfigValidatorSchema);
//# sourceMappingURL=seat-selection-rules.js.map